import {entityType} from "./module";
import {createDeleteMethod, createGetAllMethod, createPostMethod, createPutMethod} from "reactcoregk/store/actions";
import {getDefaultApiHandler} from "../../helpers/utils";

export const getAllVersions = (params) => createGetAllMethod(entityType, params, getDefaultApiHandler())
export const createVersion = (payload) => createPostMethod(entityType, payload, getDefaultApiHandler())
export const updateVersion = (payload) => createPutMethod(entityType, payload, getDefaultApiHandler())
export const deleteVersion = (payload) => createDeleteMethod(entityType, payload, getDefaultApiHandler())
